
import React from 'react'
import Alert from 'ui/Alert'
import Link from 'ui/Link'
import css from './ForgotError.module.css'

const WrongEmail = () => (
  <Alert type='warning' title='That user doesn’t exist'>
    There is no user with that email address. Do you want to <Link href='/signup' rel='external'>sign up instead?</Link>
  </Alert>
)

const GenericAlert = () => (
  <Alert type='warning' title='An unexpected error has occurred'>
    <Link href='mailto:friends@segment.com' rel='external' target='_blank'>Email us</Link> so we can help you resolve this right away!
  </Alert>
)

const ForgotError = props => {
  let alert = <GenericAlert />
  if (props.wrongEmail) {
    alert = <WrongEmail />
  }
  return <div className={css.main}>{alert}</div>
}

export default ForgotError



// WEBPACK FOOTER //
// ./components/ForgotError.js